import getLangLocale from 'I18n/utils/getLangLocale';
import { getDefaultLanguage } from 'usage-tracker-core/client/langHelper';
import usageTracker from '../utils/usageTracker';
export const trackUpdatePreferences = () => {
  usageTracker.track('updatePreferences', {
    action: 'Update Preferences'
  });
};
export const trackUnsubscribeAllPreferences = () => {
  usageTracker.track('unsubscribeAllPreferences', {
    action: 'Unsubscribe All Preferences'
  });
};
export const trackLanguageChange = selectedLangCode => {
  const currentLanguage = getLangLocale();
  const browserLanguage = getDefaultLanguage();
  const selectedLanguage = selectedLangCode;
  usageTracker.track('changePreferedLanguage', {
    action: 'Change Preferred Language',
    'from-language': currentLanguage,
    'to-language': selectedLanguage,
    'device-language-code': browserLanguage
  });
};
export const trackBackUpRedirect = reason => {
  usageTracker.track('redirectToBackup', {
    action: 'Redirect to Backup Page',
    reason
  });
};
export const trackVerifyContact = (success, error) => {
  usageTracker.track('verifyContact', {
    action: 'Verify Contact',
    success,
    'error-type': error
  });
};